import React from "react"
import { addProduct } from "../../api"
import ProductService from "../../ProductService"
import type { CartItemType, ProductServiceType } from "scripts/types"

const locale = document.documentElement.lang

const productRequestArgs = {
  id: "",
  options: [],
  locale,
}

type ProductRequestOption = {
  code: string
  options?: { code: string }[]
}

// Request handler must to handle all services
const productRequestHandler = async (data) => {
  const { id, options } = data
  productRequestArgs.id = id
  productRequestArgs.options = options

  // Call API to add product to cart
  await addProduct(productRequestArgs)

  // After the request, you can update the global cart state or perform any other actions
  // For example:
  // window.globalCart.setValue({
  //   ...window.globalCart.getValue(),
}

type CardProps = {
  item: CartItemType
  lang: {
    article: string
    size: string
    weight: string
    weight_uom: string
    services: Record<string, { name: string; uom: string; description: string }>
  }
  setIsLoadingCart: (loading: boolean) => void
}

export default function Card({ item, lang, setIsLoadingCart }: CardProps) {
  const deleteClickHandler = () => {
    // setIsLoadingCart(true)
    // Delete item from global cart
    // setTimeout(() => {
    //   window.globalCart.setValue({
    //     ...window.globalCart.getValue(),
    //     cartItems: window.globalCart.value.cartItems.filter(
    //       (k) => k.rowId !== item.rowId
    //     ),
    //   });
    // }, 0)
  }

  const onServiceChange = async (option: {
    code: string
    checked: boolean
    options: { code: string }[]
  }) => {
    let allProductOptions: ProductRequestOption[] = []
    const itemServicesValues = Object.values(item.services)

    itemServicesValues.reduce((acc, service) => {
      const selectedOption = service.options.find((option) => option.selected)
      if (selectedOption) {
        acc.push({
          code: service.code,
          options: [{ code: selectedOption.code }],
        })
      }
      return acc
    }, allProductOptions)

    if (option.checked) {
      // If option is checked, add or update it in options
      const existingOptionIndex = allProductOptions.findIndex(
        (opt) => opt.code === option.code,
      )
      if (existingOptionIndex !== -1) {
        // If option already exists, update its options
        allProductOptions[existingOptionIndex].options = option.options || []
      } else {
        // If option does not exist, add it
        allProductOptions.push({
          code: option.code,
          options: option.options || [],
        })
      }
    } else {
      // If option is unchecked, remove it from options
      allProductOptions = allProductOptions.filter((opt) => opt.code !== option.code)
    }

    const requestArgs = { id: item.id, options: allProductOptions, locale }

    addProduct(requestArgs)
  }

  return (
    <div className="cart-card flex-s">
      <div className="cart-card__img flex-c-c">
        <img src={item.options.image} alt="" />
      </div>
      <div className="cart-card__content flex-c">
        <div className="cart-card__info">
          <div className="code flex-c">
            <div className="title">{lang.article}:</div>
            <div className="num">{item.options.parent_product.articul}</div>
          </div>
          <a href={item.options.slug} className="name">
            {item.name}
          </a>
        </div>
        <ul className="cart-card__sizes flex-c">
          {item.options.size !== undefined ? (
            <li className="flex-c">
              <div className="title">{lang.size}:</div>
              <div className="num">{item.options.size}</div>
            </li>
          ) : (
            ""
          )}
          {item.options.weight_product !== undefined ? (
            <li className="flex-c">
              <div className="title">{lang.weight}:</div>
              <div className="num">
                {item.options.weight_product} {lang.weight_uom}
              </div>
            </li>
          ) : (
            ""
          )}
        </ul>
        <div className="cart-card__price">{item.price_format}</div>
        <div
          className="cart-card__remove flex-c-c"
          data-id={item.id}
          data-rowid={item.rowId}
          onClick={deleteClickHandler}
        >
          <svg className="icon-trash">
            <use xlinkHref="#trash" />
          </svg>
        </div>
      </div>
      {/* {item.services.exchange && (
        <ProductServiceExchange
          service={item.services.exchange}
          onServiceChange={onServiceChange}
          setIsLoadingCart={setIsLoadingCart}
          lang={lang}
        />
      )} */}

      {Object.entries(item.services).map(([key, service]) => {
        return (
          <ProductService
            key={key}
            service={service}
            onServiceChange={onServiceChange}
            setIsLoadingCart={setIsLoadingCart}
            lang={lang}
          />
        )
      })}

      {/* <ProductService
        key={key}
        services={service}
        onServiceChange={onServiceChange}
        setIsLoadingCart={setIsLoadingCart}
        lang={lang}
      /> */}

      {item.options.filial ? (
        <div className="shop-address">
          <svg
            className="shop-address-icon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.51758 9.0752V17.4085"
              stroke="#C4C5C5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.4824 9.0752V17.4085"
              stroke="#C4C5C5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.8518 17.4075V13.7042C11.8518 13.2131 11.6567 12.7421 11.3094 12.3949C10.9622 12.0476 10.4912 11.8525 10.0001 11.8525C9.50901 11.8525 9.03803 12.0476 8.69078 12.3949C8.34352 12.7421 8.14844 13.2131 8.14844 13.7042V17.4075"
              stroke="#C4C5C5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.66602 17.4082H18.3327"
              stroke="#C4C5C5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.58512 9.07444C2.17012 9.06444 1.24762 7.66361 1.86096 6.45611L3.29012 3.64194C3.61596 3.00027 4.30096 2.59277 5.05262 2.59277H14.9493C15.701 2.59277 16.386 3.00027 16.7118 3.64194L18.1418 6.45611C18.7551 7.66361 17.8326 9.06444 16.4176 9.07444C15.2368 9.07444 14.2793 8.26777 14.2793 7.27194V7.23194C14.2793 8.24944 13.3218 9.07444 12.141 9.07444C10.9601 9.07444 10.0026 8.24944 10.0026 7.23194C10.0026 8.24944 9.04512 9.07444 7.86429 9.07444C6.68346 9.07444 5.72596 8.24944 5.72596 7.23194V7.27194C5.72346 8.26777 4.76596 9.07444 3.58512 9.07444V9.07444Z"
              stroke="#C4C5C5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {item.options.filial}
        </div>
      ) : (
        ""
      )}
    </div>
  )
}
